import { CourseType, SectionType } from "components/server-types";
import { t } from "i18n/i18n";

export const getCourseDisplayTitle = (course: CourseType): string => {
  if (course.title) {
    return t("common.course_code_and_title", {
      code: course.code,
      title: course.title,
    });
  }
  return course.code;
};

export const getCourseAndSectionDisplayTitle = (
  course: CourseType,
  section: SectionType,
): string => {
  if (course.title) {
    return `${getCourseDisplayTitle(course)} - ${section.title}`;
  }
  return t("common.course_code_and_title", {
    code: course.code,
    title: section.title,
  });
};
